// Central place to decide whether the app is being served in the Vignan context,
// so the login page and the logout redirect stay in sync.

// Hosts that should be served the Vignan-branded login instead of the Rizee one.
export const VIGNAN_HOSTS = ["vignan.rizee.in"];

// True when the current request should show Vignan branding.
// - Production: served at a Vignan host (persistent).
// - Local testing: ?vignan=1 query param override.
export function isVignanContext() {
  if (typeof window === "undefined") return false;
  const byHost = VIGNAN_HOSTS.indexOf(window.location.hostname) !== -1;
  const byParam =
    new URLSearchParams(window.location.search).get("vignan") === "1";
  return byHost || byParam;
}
